





































































































































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter, State, Mutation} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {User} from 'firebase'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import {dropdownToggle} from '@/components/Dashboard/types';

/* tslint:disable:no-empty */

@Component({
    components: {BDropdown, BDropdownItem},
})
export default class DashboardNavBar extends Vue {
    @Prop(String) public readonly path!: string;
    @State('self', {namespace: 'userState'}) public self: MAFUser | undefined;
    @State('currentUser') public currentUser: User | undefined;
    @Getter('getUserImgURL') public getUserImgURL: any;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;
    @Mutation('setSelfRef', {namespace: 'userState'}) public setSelfRef: any;
    @Ref('coinRef') public coinRef!: dropdownToggle;

    public BASE_URL: string;
    public menuIsActive: boolean;

    constructor() {
        super();
        this.menuIsActive = false;
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    }

    public isActive(active: boolean) {
        this.menuIsActive = active;
    }

    get updateAvatar(): string | any {
        if (this.self && this.self.userType && this.self.userType === 'Organization') {
            return './img/organizations/profile_org@2x.png';
        } else {
            if (this.self && this.currentUser && this.self.avataarUrl !== '') {
                return this.self.getAvataarUrl(this.BASE_URL, true);
            }
            if (this.self && this.currentUser && this.self.imageURL !== '') {
                return this.self.imageURL;
            }
        }
    }

    get userName(): string {
        if (!this.self || !this.self.name) { return 'Guest'; }

        if (this.self.userType && this.self.userType === 'Organization') {
            return this.self.name;
        } else {
            const nameArray = this.self.name.split(' ');

            if (nameArray.length === 1) { return nameArray[0]; }
            return `${nameArray[0]} ${nameArray[1][0]}.`;
        }
    }

    @Emit('coinShow')
    public showCoins() {
        this.coinRef.toggle();
    }

    @Emit('shareShow')
    public showShare() {
        this.coinRef.toggle();
    }

    @Emit('faqShow')
    public faqShow() {
        this.coinRef.toggle();
    }
    @Emit('faqShow')
    public faqHelpShow() {
    }

    @Emit('profileShow')
    public profileShow() {
        this.coinRef.toggle();
    }

    public async signOut() {
        await this.$auth.signOut();
        this.$router.push('/');
        await this.setSelf(undefined);
        location.reload();
    }

    public openMessages() {
        (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
        this.$router.push('/dashboard/messages');
    }

    public openMeetups() {
        (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
        this.$router.push('/dashboard/meetups');
    }

    public openSetting() {
        (document.getElementById('menu-btn') as HTMLInputElement).checked = false;
        this.$router.push('/dashboard/settings');
    }

    public admin() {
        this.$router.push('/admin');
    }


}
